import type { PerfilEnGimnasio } from '../tipos/perfil'
import type { NotificacionAumentada } from '@comun/tipos/notificaciones'
import mitt from 'mitt'

export type EventosEspecificos = {
    'instancia:abrirModal': {
        instanciaID: string
    },
    'instancia:cerrarModal': {
        instanciaID?: string
    },
    'rutina:abrirModal': {
        rutinaID: string
    },
    'rutina:cerrarModal': {
        rutinaID?: string
    },
    'participante:abrirModal': {
        usuarioID: string
        gimnasioID: string
        pestanaActiva?: 'agendar' | 'membresias' | 'agenda' | 'qr'
        contexto?: 'instancia' | 'buscador' | 'perfil'
    },
    'participante:cerrarModal': {
        usuarioID?: string
    },
    'notificacion:modalRemoto': NotificacionAumentada,
    'perfilEnGimnasio:recuperar': {
        gimnasioID: string
    },
    'app:desconectarGimnasio': void,
    'video:fullscreen:abrir': {
        videoID: string
        iframeURL?: string
        nombre?: string
    },
    'video:fullscreen:cerrar': void,
    'rutaCambiada': string,
    'windowResize': boolean,
    'perfilesEnGimnasio': Record<string, PerfilEnGimnasio>,
    'llavero:rotado': string,
    'token:integrado': string,
    'appRating:abrir': {
        origen?: string
    }
}

export type EventosDeApp = {
    [K in keyof EventosEspecificos]: EventosEspecificos[K]
} & {
    [key: string]: string
}

const emitter = mitt<EventosDeApp>()

const EVENTOS_CON_BUFFER: (keyof EventosEspecificos)[] = ['notificacion:modalRemoto']
const eventosPendientes: { [K in keyof EventosDeApp]?: EventosDeApp[K][] } = {}

export const EventosDeAppAPI = {
  emitirEventoDeApp: <K extends keyof EventosDeApp>(tipo: K, payload: EventosDeApp[K]) => {
    if (EVENTOS_CON_BUFFER.includes(tipo as keyof EventosEspecificos) && !emitter.all.get(tipo as string)?.length) {
      if (!eventosPendientes[tipo]) eventosPendientes[tipo] = []
      eventosPendientes[tipo]!.push(payload)
      return
    }
    emitter.emit(tipo, payload)
  },
  capturarEventoDeApp: <K extends keyof EventosDeApp>(tipo: K, handler: (payload: EventosDeApp[K]) => void) => {
    emitter.on(tipo, (payload: EventosDeApp[K]) => {
      handler(payload)
    })

    if (eventosPendientes[tipo]?.length) {
      while (eventosPendientes[tipo]!.length > 0) {
        const evento = eventosPendientes[tipo]!.shift()
        if (evento !== undefined) handler(evento)
      }
    }
  }
  // limpiarEventosDeApp: () => {
  //     // Vaciar eventosPendientes
  //     for (const tipo in eventosPendientes) {
  //         delete eventosPendientes[tipo]
  //     }
  // }
}